<template>
  <!-- v-if="!loading" -->
  <div class="login_content">
    <!-- <div class="platform">
      <h1>中芯</h1>
      <h1>新零工经济服务平台</h1>
    </div> -->
    <div class="login-form">
      <img
        v-if="!isXyk"
        class="logo"
        alt="logo"
        src="@assets/zx_new_logo.png"
      />
      <img v-else class="logo" alt="logo" src="@assets/ql_logo.png" />
      <div class="title">新零工经济服务平台</div>
      <div class="line clearfix">
        <div class="col col-mid">
          <input
            style="border: none; background: transparent"
            type="text"
            placeholder="请输入手机号"
            v-model="phoneNum"
            v-on:blur="checkPhone"
            maxlength="11"
          />
        </div>
      </div>
      <div v-if="err.phone" class="txt-red err-info">
        <i class="iconfont icon-info-circle"></i>
        {{ err.phone }}
      </div>
      <div class="line">
        <input
          style="border: none; background: transparent"
          type="text"
          placeholder="请输入验证码"
          size="6"
          v-model="code"
          v-on:blur="checkCode"
          maxlength="6"
        />
        <span
          class="col col-right txt-red"
          @click="throttleSendVeriFn"
          v-if="seconds == 0"
          >发送验证码</span
        >
        <span class="col col-right txt-red" v-else>{{ seconds }}秒</span>
      </div>
      <div v-if="err.code" class="txt-red err-info">
        <i class="iconfont icon-info-circle"></i>
        {{ err.code }}
      </div>

      <div type="danger" size="large" class="login_btn" @click="loginFn"></div>
      <div v-if="!isXyk" class="copyright">
        {{ `Copyright © 2024 ${record.comnpanyName} ` }}
        <a
          href="http://www.beian.miit.gov.cn"
          target="_blank"
          style="color: rgba(0, 0, 0, 0.45)"
          rel="noopener"
          >{{ record.icpNo }}</a
        >
      </div>
    </div>
    <div class="check-info">
      <div class="mint-radiolist-label" @click="handleToggleAgreementFlag">
        <span>
          <!-- <input type="radio" class="mint-radio-input" value="true" v-model="agreementFlag" /> -->
          <!-- <img class="no-agree"   src="../../assets/images/login/no-agree.png" v-if="!agreementFlag" />
          <img
            class="agree"
            src="../../assets/images/login/agree.png"
            v-else-if="agreementFlag"
          /> -->
        </span>
        <!-- <span class="mint-radio-label">
          我已同意
          <a class="agreement" @click="toCheckFn"
            >《{{
              isXyk ? "荆州基地" : "中芯云服"
            }}平台用户隐私协议及注册协议》</a
          >
        </span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { verifyPhone, verifyStr, throttle, getParams } from "@utils/common";
import { getVeriCode, loginning, inputIdNum } from "@api/login";
import { setInterval, clearInterval } from "timers";
import store from "@/store.js";
import { MessageBox, Toast, Indicator } from "mint-ui";
import record from "@utils/record.js";
import { getWeChatAuthorization } from "@utils/weChatAuthorization";
import md5 from "js-md5";
let timer;
export default {
  components: {},
  data() {
    return {
      err: {
        phone: "",
        code: "",
      },
      phoneNum: "",
      code: "",
      seconds: 0,
      agreementFlag: false,
      record,
      // loading: true,
      isXyk: window.location.origin.indexOf("h5.jzbase-saas") > -1,
    };
  },
  created() {
    // Indicator.open("授权中...");
    // timer = setTimeout(() => {
    // Indicator.close();
    // this.loading = false;
    // }, 1500);
    // getWeChatAuthorization().then(res => {
    //   this.loading = false;
    //   Indicator.close();
    //   if (!res) {
    //     return;
    //   }
    //   if (res.openid) {
    //     this.$store.commit("setWxInfo", res);
    //     sessionStorage.setItem("setWxInfo", JSON.stringify(res));
    //   } else {
    //     this.$store.commit("setUser", res);
    //     sessionStorage.setItem("user", JSON.stringify(res));
    //     const urlData = getParams(window.location.href);
    //     if (urlData.comer) {
    //       this.$router.push("/UploadVideo/index");
    //       return;
    //     }
    //     if (res.state === 2) {
    //       this.$router.replace("/taskCenter");
    //     } else {
    //       if (res.idCardType === 1 || res.idCardType === null) {
    //         this.$router.replace("/hotTip");
    //       } else {
    //         this.$router.replace("/user/confirmApplyUser");
    //       }
    //     }
    //   }
    // });
  },
  beforeDestroy() {
    clearInterval(timer);
    const messageBox = document.getElementsByClassName(
      "mint-msgbox-btn mint-msgbox-cancel "
    );

    if (messageBox && messageBox[0]) {
      messageBox[0].click();
    }
  },
  methods: {
    handleShowIdMsg() {
      MessageBox.prompt("请输入身份证号码，完善用户信息", "请输入身份证号")
        .then(({ value, action }) => {
          window.scroll(0, 0);
          if (action === "confirm") {
            inputIdNum({
              phone: this.phoneNum,
              idNum: value,
            }).then((res) => {
              Toast(res.data.message);
            });
          }
        })
        .catch((err) => {
          window.scroll(0, 0);
        });
    },
    handleToggleAgreementFlag() {
      this.agreementFlag = !this.agreementFlag;
    },
    checkPhone() {
      // 检测手机号码合法性
      window.scroll(0, 0);
      let verifyInfo = verifyPhone(this.phoneNum);
      this.err.phone = verifyInfo.done ? "" : verifyInfo.errMsg;
    },
    checkCode() {
      // 检测验证码
      window.scroll(0, 0);
      let verifyInfo = verifyStr(this.code, "验证码");
      this.err.code = verifyInfo.done ? "" : verifyInfo.errMsg;
    },
    throttleSendVeriFn: throttle(function () {
      this.sendVeriFn();
    }, 2000),
    sendVeriFn() {
      this.err.phone = "";
      if (this.phoneNum == "") {
        this.err.phone = "请输入手机号码";
        return;
      }
      if (!verifyPhone(this.phoneNum).done) {
        return;
      }
      const key = md5(`${md5(`${this.phoneNum}`)}zhongxicz`);
      let data = {
        phone: this.phoneNum,
        key,
      };
      getVeriCode(data).then((res) => {
        const { data } = res;
        if (data.code === 200) {
          // 验证码跑秒
          let secondsNum = 20;
          var that = this;
          let secondsInter = setInterval(() => {
            if (secondsNum == 0) {
              //结束跑秒
              that.seconds = 0;
              clearInterval(secondsInter);
            }
            that.seconds = secondsNum;
            secondsNum--;
          }, 1000);
        }
        // else if (data.code === 2001) {
        //   this.handleShowIdMsg();
        // }
        else {
          this.err.phone = data.message;
        }
      });
    },
    loginFn() {
      //登录
      this.checkPhone();
      this.checkCode();
      if (this.err.phone !== "" || this.err.code !== "") return;
      // if (!this.agreementFlag) {
      //   MessageBox.alert(
      //     `请阅读并同意《${
      //      this.isXyk ? "数字科技" : "中芯云服"
      //     }平台用户隐私协议及注册协议》后再登录`,
      //     ""
      //   );
      //   return;
      // }
      let data = {
        phone: this.phoneNum,
        code: this.code,
        ...this.$store.getters.getWxInfo,
      };
      // 登录接口
      loginning(data)
        .then((res) => {
          if (res.data.code !== 200) {
            this.err.code = res.data.message;
            this.$store.commit("removeStorage");
            return;
          }
          let user = { ...res.data.data };
          user.phone = this.phoneNum;
          this.$store.commit("setUser", user);
          sessionStorage.setItem("user", JSON.stringify(user));
          // const urlData = getParams(window.location.href);
          // console.log(urlData);
          // if (urlData.comer) {
          //   this.$router.push("/UploadVideo/index");
          //   return;
          // }

          // let xbgSigntype = user.isXbgSign;
          // if (xbgSigntype !== undefined && xbgSigntype) {
          //   sessionStorage.setItem("isXbgSign", user.isXbgSign);
          // }

          // 定制页面
          if (user.isNameAndPhone !== undefined && user.isNameAndPhone) {
            this.$router.replace("/user/collectionInfo");
          } else {
            // 上传了图片并完成实名，可以直接到任务列表
            let isUploadedIDImg = user.isUploadedIDImg;
            if (user.state === 2 && isUploadedIDImg) {
              this.$router.replace("/taskCenter");
            } else {
              if (user.idCardType === 1 || user.idCardType === null) {
                // this.$router.push("/hotTip");
                this.$router.push("/user/selectArea");
              } else {
                this.$router.push("/user/confirmApplyUser");
              }
            }
          }


        })
        .catch((err) => {});
    },
    toCheckFn(e) {
      e.cancelBubble = true;
      this.$router.push("/login/agreement");
    },
  },
};
</script>

<style lang="less" scoped>
.login_content {
  position: relative;
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  padding: 0 16px;
  // padding-bottom: 54px;
  background: url("../../assets/images/login/login_bg.png") no-repeat;
  background-size: cover;
}
.flex {
  display: flex;
  justify-content: center;
  align-content: center;
}
.logo {
  width: 65%;
  display: block;
  margin: 0 auto;
}
.title {
  color: white;
  font-size: 0.8rem;
  text-align: center;
  margin-bottom: 20px;
  // position: absolute;
  // top: 28vh;
  // width: 85%;
  font-family: PingFangSC-Semibold, sans-serif;
}
.mint-radio-core-activity {
  background-color: #ffffff;
  border-color: #26a2ff;
  border-width: 6px;
  box-sizing: border-box;
}
.login-form {
  padding: 0 24px 44px 24px;
  margin-top: 22px;
  border-radius: 12px;
  // background: #ffffff;
  position: relative;
  .line {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 24px;
    background: #f7f6fb;
    border-radius: 14px;
    // margin-top: 23px;
    margin-bottom: 10px;
    height: 35pt;
    text-align: center;
    .col {
      white-space: nowrap;
      float: left;
      font-size: 12px;
      // &.col-left {
      //   width: 2.5rem;
      //   span {
      //     display: inline-block;
      //     padding-bottom: 2px;
      //   }
      // }
      // &.col-mid {
      //   position: absolute;
      //   top: 0;
      //   bottom: 1px;
      //   left: 2.7rem;
      //   right: 5.3rem;
      // }
      &.col-right {
        float: right;
        width: 5.3rem;
        color: #1271ff;
        text-align: right;
      }
    }
    input {
      text-align: left;
      font-size: 12px;
      flex: 1;
      height: 100%;
    }
  }
  .err-info {
    font-size: 0.9rem;
    margin-bottom: 10px;
  }
}
.check-info {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 54px;
  width: 100%;
  display: block;
  align-self: flex-end;
  white-space: nowrap;
  font-size: 0.75rem;
  color: #ffffff;
  opacity: 0.6;
  .agreement {
    color: white;
  }
  .mint-radiolist-label {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    height: 2.25rem;
  }
}
.copyright {
  display: none;
  position: fixed;
  left: 0;
  bottom: 3.2vw;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  text-align: center;
  width: 100%;
}
@media screen and (min-width: 1000px) {
  .copyright {
    display: block;
  }
}
.login_btn {
  margin-top: 48px;
  // background: #0070ff;
  height: 130px;
  border-radius: 14px;
  background: url("../../assets/images/login/submit.png") no-repeat;
  background-size: cover;
  background-position: 45%;
}
.agree,
.no-agree {
  width: 15px;
  height: 15px;
}
</style>
